import { render, staticRenderFns } from "./LexonChronometerComponent.vue?vue&type=template&id=cfa3e4c4&scoped=true&lang=pug"
import script from "./LexonChronometerComponent.vue?vue&type=script&lang=ts"
export * from "./LexonChronometerComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonChronometerComponent.vue?vue&type=style&index=0&id=cfa3e4c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa3e4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfa3e4c4')) {
      api.createRecord('cfa3e4c4', component.options)
    } else {
      api.reload('cfa3e4c4', component.options)
    }
    module.hot.accept("./LexonChronometerComponent.vue?vue&type=template&id=cfa3e4c4&scoped=true&lang=pug", function () {
      api.rerender('cfa3e4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonChronometer/LexonChronometerComponent.vue"
export default component.exports